import { Form, Input, Select } from '@maxtropy/components';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { apiV2EnergyMediumWaterMapListByUnitLevel1Post } from '@maxtropy/device-customer-apis-v2';
import LevelSelect from '../../WaterConf/components/LevelSelect';
import { AnalysisUnit } from './BindUnitModal';
import { DefaultOptionType } from 'antd/es/select';

interface EnergyFlowRowProps {
  index: number;
  isEdit: boolean;
  unitGroup: AnalysisUnit[];
  onLoadingChange?: (loading: boolean) => void;
}

const EnergyFlowRow = ({ index, isEdit, unitGroup, onLoadingChange }: EnergyFlowRowProps) => {
  const form = Form.useFormInstance();
  const [mediumSelections, setMediumSelections] = useState<DefaultOptionType[]>([]);
  const watchedGroup = Form.useWatch(`energyGroupId${index}`, form);

  useEffect(() => {
    if (!watchedGroup) {
      setMediumSelections([]);
      form.setFieldValue(`mediumId${index}`, undefined);
      form.setFieldValue(`showEnergyGroupName${index}`, undefined);
      return;
    }
    //  根据用能单元组获取介质选项
    onLoadingChange?.(true);
    apiV2EnergyMediumWaterMapListByUnitLevel1Post({ energyUnitGroupId: watchedGroup })
      .then(res => {
        const options = res.list?.map(i => ({ label: i.name, value: i.id })) ?? [];
        setMediumSelections(options);
        // 若当前选中的介质不在选项中，则清空
        const currentMediumId = form.getFieldValue(`mediumId${index}`);
        if (currentMediumId && !options.some(o => o.value === currentMediumId)) {
          form.setFieldValue(`mediumId${index}`, undefined);
        }
      })
      .catch(() => undefined)
      .finally(() => onLoadingChange?.(false));
  }, [watchedGroup]);

  return (
    <Col span={24} style={{ marginBottom: '24px' }}>
      <Row gutter={44}>
        <Col flex="0 0 345px">
          <Form.Item name={`energyGroupId${index}`} style={{ marginBottom: 0 }}>
            <Select
              optionFilterProp="label"
              disabled={!isEdit}
              placeholder="请选择"
              options={unitGroup.map(u => ({ label: u.name, value: u.id }))}
              allowClear={true}
              showSearch
            />
          </Form.Item>
        </Col>
        <Col flex="0 0 345px">
          <Form.Item
            name={`levelRange${index}`}
            style={{ marginBottom: 0 }}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && value.fromLevel > value.toLevel) {
                    return Promise.reject(new Error('下级节点数需大于等于上级节点数'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <LevelSelect disabled={!isEdit} energyUnitGroupId={watchedGroup} onLoadingChange={onLoadingChange} />
          </Form.Item>
        </Col>
        <Col flex="0 0 345px">
          <Form.Item
            name={`mediumId${index}`}
            style={{ marginBottom: 0 }}
            rules={[
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const energyGroupId = getFieldValue(`energyGroupId${index}`);
                  if (energyGroupId && !value) {
                    return Promise.reject(new Error('请选择介质'));
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Select disabled={!isEdit} placeholder="请选择" options={mediumSelections} allowClear />
          </Form.Item>
        </Col>
        <Col flex="0 0 345px">
          <Form.Item name={`showEnergyGroupName${index}`} style={{ marginBottom: 0 }}>
            <Input placeholder="请输入" disabled={!isEdit} maxLength={20} />
          </Form.Item>
        </Col>
      </Row>
    </Col>
  );
};

export default EnergyFlowRow;
